export const UPDATE_SCHEDULED_REPORT_SUCCESS = 'UPDATE_SCHEDULED_REPORT_SUCCESS';
export const UPDATE_SCHEDULED_REPORT_ERROR = 'UPDATE_SCHEDULED_REPORT_ERROR';

export const FETCH_SCHEDULED_REPORT_FOR_EDIT_ERROR = 'FETCH_SCHEDULED_REPORT_FOR_EDIT_ERROR';

export const DELETE_SCHEDULED_REPORT_SUCCESS = 'DELETE_SCHEDULED_REPORT_SUCCESS';
export const DELETE_SCHEDULED_REPORT_ERROR = 'DELETE_SCHEDULED_REPORT_ERROR';

export const SAVE_DYNAMIC_REPORT_SUCCESS = 'SAVE_DYNAMIC_REPORT_SUCCESS';
export const SAVE_DYNAMIC_REPORT_ERROR = 'SAVE_DYNAMIC_REPORT_ERROR';
